//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by spaefr65 on 17.09.2015.
 */

(function () {
    'use strict';

    angular.module('container.layout', []);

})();